import { ReactNode, useEffect, useState} from 'react';
import { useLoader } from "../../hooks/useLoader";
import ApiService from '../../services/ApiServiceClass';
import CustomInfoModal from '../Modals/CustomInfoModal';

const ArchiveSettings = () => {
    const loader = useLoader();
    const [openInfoModal, setOpenInfoModal] = useState(false);
    
    const archiveRequests = () => {
        loader?.setIsLoading(true);
        try {
            ApiService.archivePreviousYearRequests()
                .then(() => {
                    setOpenInfoModal(true);
                    loader?.setIsLoading(false);
                });
        } catch(error) {
            loader?.setIsLoading(false);
        }
    }

    return (
        <>
            <div className="rounded-sm border border-stroke bg-white py-6 px-7.5 shadow-default dark:border-strokedark dark:bg-boxdark">
                <h5 className="text-xl font-semibold text-black dark:text-white">
                    Archieve Settings
                </h5>
                <fieldset className="flex flex-col max-w-md gap-4">
                    
                </fieldset>
                <button type="submit"
                                        className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mb-10 mr-2 mt-5"
                                        onClick={archiveRequests}
                                    >
                        Archive Previous Year Requests
                </button>

                <CustomInfoModal openModal={openInfoModal} setOpenModal={setOpenInfoModal} message='Archiving Complete' />
            </div>  
        </>
    )
}

export default ArchiveSettings;